export default __webpack_public_path__ + "static/media/Weathertop.f71226a8.ttf";